import { render } from "./DsiFormModal.vue?vue&type=template&id=0798a5eb&scoped=true&ts=true&lang=pug"
import script from "./DsiFormModal.vue?vue&type=script&lang=ts"
export * from "./DsiFormModal.vue?vue&type=script&lang=ts"

import "./DsiFormModal.vue?vue&type=style&index=0&id=0798a5eb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0798a5eb"]])

export default __exports__